import React from 'react'
import {  useTranslation } from 'react-i18next';
import {MwInputText, MwTextArea} from '../../ui/';
import CardAmount from '../../ui/CardAmount';
import PromoCodeBox from '../PromoCodeBox';
import TagList from '../../ui/TagList';

const InvFormFooter = ({
    invNotes,
    setInvNotes,
    invTotalAmount,
    invCurrency,
    promoCode,
    setPromoCode,
    discount,
    vat,
    netTotal,
    havePromoCode,
    setHavePromoCode,
    promoCodeHandler,
    discountOnchange,
    SETTING_PRICE_INCLUDE_VAT,
    SETTING_INV_CURRENCY,
    tagList,
    setTagList,
    selectedCurrency,
    formatWithCurrency,
    totalAmountWithDiscount,
    amountFormat,
    formatter
}) => {
    const [t] = useTranslation('global')
    return (
        <div id='footer-inv' className='py-2' >
        {/* <MwTextArea 
            placeholder={t('invoice.enterNotes')}
            value={invNotes}
            onChange={(e)=>setInvNotes(e.target.value)}
            /> */}
   

        <div className='flex md:flex-row flex-col gap-2  items-top p-3 justify-between text-sm'>
            <div className="flex-1  flex items-top justify-between">
                <CardAmount
                    label= {t("quotes.totalBeforeDiscount")}
                    amountValue={formatWithCurrency(invTotalAmount ,selectedCurrency,formatter, amountFormat)}
                    //footerValue={formatter.format(SETTING_INV_CURRENCY)}
                    />
                <div id='discount-card' className=' flex-1 text-center '>
                    <div className=' text-[#251658] text-xs'> {t("quotes.totalOnDiscount")}  </div>
                    <MwInputText
                        value={discount}
                        // disabled={disabledDiscount}
                        disabled={true}
                        // placeholder={t('invoice.discount')}
                        classNameInput = 'font-bold py-2 text-gray-600 !text-[16px] text-center'
                        size='sm'
                        onChange={(e)=>discountOnchange(e.target.value)}
                    />
                    {/* <div className='text-slate-400 text-xs'>{ discount && SETTING_INV_CURRENCY.toUpperCase() }</div> */}
                </div>
                <CardAmount
                    label={t("quotes.totalAfterDiscount")}
                    amountValue={ formatWithCurrency(totalAmountWithDiscount,selectedCurrency,formatter, amountFormat) }
                    // footerValue={SETTING_INV_CURRENCY.toUpperCase()}
                    />
            </div>
            <div className="flex-1 flex items-center justify-between">
                <CardAmount
                    label={t('invoice.vatAmount')}
                    amountValue={formatWithCurrency(vat ,selectedCurrency,formatter, amountFormat)}
                    // footerValue={SETTING_INV_CURRENCY.toUpperCase()}
                    />
                <CardAmount
                    label={t('invoice.netTotal')}
                    amountValue={formatWithCurrency(netTotal ,selectedCurrency,formatter, amountFormat)}
                    // footerValue={SETTING_INV_CURRENCY.toUpperCase()}
                    />                        
            </div>
        </div>
{/*                  
        <div className='pt-2 flex flex-col justify-center items-center'>
            { SETTING_PRICE_INCLUDE_VAT === 'true' ?
                <div className='flex justify-center items-center text-xs text-slate-400 '>{t('invoice.priceIncludesVat')}</div> : 
                <div className='text-xs text-slate-400 text-center'>{t('invoice.priceNotIncludesVat')}</div> 
                
            }
        </div> */}
    </div>
    )
}

export default InvFormFooter